import { render, staticRenderFns } from "./CalendarNote.vue?vue&type=template&id=e8faa816&scoped=true&"
import script from "./CalendarNote.vue?vue&type=script&lang=js&"
export * from "./CalendarNote.vue?vue&type=script&lang=js&"
import style0 from "./CalendarNote.vue?vue&type=style&index=0&id=e8faa816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8faa816",
  null
  
)

export default component.exports